module.exports = __webpack_public_path__ + "static/media/as5tj538.50929514.png";